import { render, staticRenderFns } from "./NewEducatorSidebarForm.vue?vue&type=template&id=07218f04"
import script from "./NewEducatorSidebarForm.vue?vue&type=script&lang=js"
export * from "./NewEducatorSidebarForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports